import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, MessageCircleQuestion } from "lucide-react";

export default function AdminFeedback() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/feedback").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-primary" /></div>;

  return (
    <div data-testid="admin-feedback-page">
      <div className="flex items-center gap-2">
        <MessageCircleQuestion className="w-6 h-6 text-primary" />
        <h1 className="font-heading font-black text-3xl tracking-tight">Feedback</h1>
      </div>
      <p className="text-muted-foreground mt-2">What visitors say is their #1 process pain — straight from the site.</p>

      {rows.length === 0 ? (
        <div className="mt-10 text-center text-muted-foreground border border-dashed border-border py-16">
          No feedback yet. It'll appear here as visitors answer the question.
        </div>
      ) : (
        <div className="mt-8 space-y-4">
          {rows.map((f) => (
            <div key={f.id} className="bg-white border border-border p-5" data-testid="feedback-row">
              <p className="text-foreground">{f.message}</p>
              <div className="text-xs text-muted-foreground mt-3 flex flex-wrap gap-3">
                {f.email && <span>✉ {f.email}</span>}
                {f.path && <span className="font-mono">{f.path}</span>}
                <span>{new Date(f.created_at).toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
